import React from 'react';
import { useTranslation } from 'react-i18next';
import { useCart } from '../../../contexts/CartContext';
import '../Checkout.css';

interface OrderSummarySidebarProps {
  shippingMethod: string;
  getShippingCost: () => number;
  getTotalPrice: () => number;
  getTax: () => number;
  getTotal: () => number;
}

const OrderSummarySidebar: React.FC<OrderSummarySidebarProps> = ({
  shippingMethod,
  getShippingCost,
  getTotalPrice,
  getTax,
  getTotal
}) => {
  const { t } = useTranslation();
  const { cartItems } = useCart();

  return (
    <div className="order-summary-sidebar">
      <h3>{t('checkout.orderSummary')}</h3>
      
      <div className="summary-section">
        <div className="summary-row">
          <span>{t('checkout.subtotal')}</span>
          <span>₪{getTotalPrice().toFixed(2)}</span>
        </div>
        <div className="summary-row">
          <span>{t('checkout.shippingLabel')}</span>
          <span>₪{getShippingCost().toFixed(2)}</span>
        </div>
        <div className="summary-row">
          <span>{t('checkout.tax')}</span>
          <span>₪{getTax().toFixed(2)}</span>
        </div>
        <div className="summary-row total">
          <span>{t('checkout.total')}</span>
          <span>₪{getTotal().toFixed(2)}</span>
        </div>
      </div>

      <div className="cart-items">
        {cartItems.map((item) => (
          <div key={item.product._id} className="cart-item">
            <img src={item.product?.images?.[0]} alt={item.product.productName} className="item-image" />
            <div className="item-info">
              <h4>{item.product.productName}</h4>
              <p>{t('checkout.qty')} {item.quantity}</p>
              <div className="item-price">
                <span className="current-price">
                  ₪{item.product.salePrice > 0 && item.product.sale
                    ? (typeof item.product.salePrice === 'string'
                        ? parseFloat(item.product.salePrice)
                        : item.product.salePrice).toFixed(2)
                    : (typeof item.product.price === 'string'
                        ? parseFloat(item.product.price)
                        : item.product.price).toFixed(2)}
                </span>
                {item.product.sale && item.product.salePrice > 0 && (
                  <span className="original-price">
                    ₪{(typeof item.product.price === 'string'
                      ? parseFloat(item.product.price)
                      : item.product.price).toFixed(2)}
                  </span>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default OrderSummarySidebar;

